export default __webpack_public_path__ + "static/media/bannerBgMb.c7bc0366.png";